import React from "react";
import { Download, UserPlus, ShoppingBag, TrendingUp } from "lucide-react";
import { LANDING } from "@/constants/testIds";

const STEPS = [
  { icon: Download, title: "Create the workspace", body: "Register on the web, choose a starting plan or free trial, and enter without an automatic charge." },
  { icon: UserPlus, title: "Model the operation", body: "Add the business, branches, team permissions, and products that matter first." },
  { icon: ShoppingBag, title: "Capture work at the source", body: "Record sales, stock movement, expenses, and customer credit as the day happens—even through weak connectivity." },
  { icon: TrendingUp, title: "Run the next decision", body: "Use the dashboard and assistant to spot stock pressure, unpaid balances, performance, and the action that cannot wait." },
];

export const HowItWorks = () => {
  return (
    <section
      id="how-it-works"
      data-testid={LANDING.howItWorks}
      className="bg-[#F7FAF9] py-24 md:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <div className="max-w-3xl">
          <span className="text-xs md:text-sm tracking-[0.2em] uppercase font-bold text-[#D96C4A]">How it works</span>
          <h2 className="mt-4 font-display text-3xl md:text-4xl font-semibold leading-[1.1] text-[#0A2424] tracking-tight">
            Set up once. <span className="italic text-[#0E6B6B]">Get more useful with every transaction.</span>
          </h2>
        </div>

        <ol className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 relative">
          <div className="hidden lg:block absolute top-7 left-[12.5%] right-[12.5%] h-px bg-gradient-to-r from-[#0E6B6B]/30 via-[#D96C4A]/40 to-[#0E6B6B]/30" aria-hidden="true" />
          {STEPS.map((s, i) => (
            <li
              key={s.title}
              className="relative rounded-3xl bg-white p-7 border border-[#0E6B6B]/8 shadow-[0_8px_30px_rgb(0,0,0,0.03)]"
              data-testid={`how-step-${i + 1}`}
            >
              <div className="flex items-center gap-3 mb-5">
                <div className="h-14 w-14 rounded-2xl bg-[#0E6B6B] text-white flex items-center justify-center font-display text-xl font-semibold">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <s.icon className="h-6 w-6 text-[#0E6B6B]" strokeWidth={1.6} />
              </div>
              <h3 className="font-display text-xl font-semibold text-[#0A2424]">{s.title}</h3>
              <p className="mt-2 text-[15px] text-[#4B5E5E] leading-relaxed">{s.body}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default HowItWorks;
